import { Observable } from 'rxjs';
import { SmoMoonList } from '../../Models/Smo/SmoMoonList';
import { Request } from '../Request/Request';
import { MoonListRequestInput } from './Models/MoonListRequestInput';
import { MoonListManager } from './MoonListManager';

export class SmoMoonListManager implements MoonListManager {
  public getMoonLists(): Observable<SmoMoonList[]> {
    return new Request().withPath('/moon/list').get();
  }

  public getPopularMoonLists(): Observable<SmoMoonList[]> {
    return new Request().withPath('/moon/list/popular').get();
  }

  public getMoonListWithId(id: string): Observable<SmoMoonList> {
    return new Request().withPath(`/moon/list/${id}`).get();
  }

  public getCurrentUserMoonList(): Observable<SmoMoonList[]> {
    return new Request().withPath('/user/me/lists').get();
  }

  public searchMoonLists(name: string): Observable<SmoMoonList[]> {
    return new Request().withPath('/moon/list/search').withParams({ s: name }).get();
  }

  public favoriteMoonListWithId(id: string): Observable<{ action: 'added' | 'removed'; moonList: SmoMoonList }> {
    return new Request().withPath(`/user/me/list/${id}/favorite`).post();
  }

  public createMoonListWithId(input: MoonListRequestInput): Observable<void> {
    return new Request().withPath('/moon/list').withBody(input).post();
  }

  public updateMoonListWithId(id: string, input: MoonListRequestInput): Observable<SmoMoonList> {
    return new Request().withPath(`/moon/list/${id}`).withBody(input).post();
  }

  public deleteMoonListWithId(id: string): Observable<void> {
    return new Request().withPath(`/moon/list/${id}`).delete();
  }
}
